<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white mx-3 mt-3 rounded-t-md border-b-0.5">
      <div class="flex justify-between items-center p-2">
        <p class="font-semibold">This Organization</p>
        <button
          @click="updateOrganizationInfo"
          class="bg-green-500 text-white rounded-full px-3 py-1 text-sm"
        >
          Save Changes
        </button>
      </div>
    </div>

    <div class="p-3 bg-white mx-3 rounded-b-md">
      <transition name="fade">
        <div
          v-if="loading"
          class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
        >
          <loader class="center-h-v" />
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="update_success"
          class="p-1 text-center text-sm w-full bg-green-200"
        >
          {{ update_success }}
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="update_error"
          class="p-1 text-center text-sm w-full bg-green-200"
        >
          {{ update_error }}
        </div>
      </transition>
      <!-- Edit basic info -->
      <div class="py-5">
        <img class="h-10 sm:h-14 object-contain" :src="info.Logo" />
      </div>
      <div class="pb-5 mt-5">
        <h1 class="font-semibold">Organization Information</h1>
        <p class="text-sm italic">
          Edit basic Information about your organization
        </p>
      </div>
      <div class="flex flex-wrap gap-5">
        <div class="w-max">
          <p class="text-xs pb-1">Name</p>
          <input
            type="text"
            v-model="info.Name"
            required
            class="p-1 bg-gray-100 rounded focus:ring-1 focus:ring-primary focus:bg-white"
          />
        </div>
        <div>
          <p class="text-xs">Contact Email</p>
          <input
            type="text"
            v-model="info.Email"
            required
            class="p-1 bg-gray-100 rounded focus:ring-1 focus:ring-primary focus:bg-white"
          />
        </div>
        <div>
          <p class="text-xs">Contact Phone No.</p>
          <input
            type="text"
            v-model="info.PhoneNumber"
            required
            class="p-1 bg-gray-100 rounded focus:ring-1 focus:ring-primary focus:bg-white"
          />
        </div>

        <div>
          <p class="text-xs">Address</p>
          <input
            type="text"
            v-model="info.Address"
            required
            class="p-1 bg-gray-100 rounded focus:ring-1 focus:ring-primary focus:bg-white"
          />
        </div>

        <div>
          <p class="text-xs">Logo</p>
          <input
            type="file"
            class="p-1 bg-gray-100 rounded focus:ring-1 focus:ring-primary focus:bg-white"
            @change="handleFileUpload"
          />
        </div>
      </div>
      <hr class="my-5" />

      <div class="pb-2">
        <h1 class="font-semibold">Licensing Information</h1>
        <p class="text-sm italic">Update or action on your license</p>
      </div>
      <div class="grid lg:grid-cols-2 gap-5 grid-cols-1 justify-items-center">
        <div class="flex flex-col gap-y-2 w-full text-sm">
          <div class="flex items-center justify-between gap-5">
            <p>Status</p>
            <p class="font-semibold">
              <span class="text-red-500">Expired</span>
            </p>
          </div>
          <div class="flex items-center justify-between gap-5">
            <p>License Type</p>
            <p class="font-semibold">
              <span class="text-green-500">Trial</span>
            </p>
          </div>
          <div class="flex items-center justify-between gap-5">
            <p>License Start Date</p>
            <p class="font-semibold">5 Oct 2022</p>
          </div>
          <div class="flex items-center justify-between gap-5">
            <p>License Expiry</p>
            <p class="font-semibold">14 Dec 2022</p>
          </div>
          <div class="flex items-center justify-between gap-5">
            <p>User Limit</p>
            <p class="font-semibold">
              10
              <span class="italic font-normal"
                >(2 Managers, 8 Normal Employees)</span
              >
            </p>
          </div>
          <div class="flex items-center justify-between gap-5">
            <p>Current User Count</p>
            <p class="font-semibold">
              14
              <span class="italic font-normal"
                >(4 Managers, 10 Normal Employees)</span
              >
            </p>
          </div>
        </div>
        <div class="lg:w-1/2 w-full bg-gray-100 p-5 rounded-lg">
          <div class="flex flex-col justify-center h-full items-center gap-5">
            <p class="text-lg font-semibold">Your License has Expired</p>
            <button
              @click="renewLicense"
              class="w-max text-sm p-2 bg-primary text-white rounded-full"
            >
              Renew License
            </button>
          </div>
        </div>
      </div>
      <div class="bg-gray-100 rounded-md p-5 lg:w-1/2 w-full mt-5">
        <p class="pb-2 italic">Need more users?</p>
        <div class="flex flex-wrap gap-5 items-center">
          <div>
            <p class="text-xs pb-1">HR Managers</p>
            <input
              type="number"
              required
              class="p-1 min-w-min rounded focus:ring-1 focus:ring-primary"
            />
          </div>
          <div>
            <p class="text-xs pb-1">HR Managers</p>
            <input
              type="number"
              required
              class="p-1 min-w-max bg-gray- rounded focus:ring-1 focus:ring-primary"
            />
          </div>
          <div>
            <p class="invisible">km</p>
            <button
              class="w-max text-xs p-2 bg-primary text-white rounded-full"
            >
              Update License
            </button>
          </div>
        </div>
      </div>
      <hr class="my-5" />
      <div class="opacity-30 hover:opacity-100 mb-5">
        <div class="pb-2">
          <h1 class="font-semibold">Unsubscribe</h1>
          <p class="text-sm">
            Do you want to remove your organization from TalantaHR
          </p>
        </div>
        <div>
          <button
            class="border-1.5 border-red-500 text-red-500 rounded-full px-6 py-1 text-sm"
          >
            Begin removing your organization
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "ThisOrganization",
  components: { Loader },
  data() {
    return {
      logo: "",
      update_success: null,
      update_error: null,
      organizationInfo: null,
      loading: false,
      info: {
        Name: "",
        Email: "",
        PhoneNumber: "",
        Address: "",
        Logo: "",
      },
    };
  },

  created() {
    // this.logo = this.$store.getters.getOrganizationDetails.logo;
    this.getOrganizationInfo();
  },

  computed: {
    ...mapGetters(["getToken", "getOrganization"]),
  },

  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.info.Logo = file;
    },

    updateOrganizationInfo() {
      const formData = new FormData();
      formData.append("Name", this.info.Name);
      formData.append("Email", this.info.Email);
      formData.append("PhoneNumber", this.info.PhoneNumber);
      formData.append("Address", this.info.Address);
      formData.append("Logo", this.info.Logo);

      const config = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "multipart/form-data",
        },
      };
      this.loading = true;
      axios
        .put(
          `${this.getOrganization}/organization/information/v1/edit`,
          formData,
          config
        )
        .then((response) => {
          if (response.data.StatusCode === 200) {
            this.loading = false;

            this.update_success = response.data.StatusMessage;

            setTimeout(() => {
              this.update_success = null;
              this.getOrganizationInfo();
            }, 2500);
          } else {
            this.update_error = response.data.StatusMessage;

            setTimeout(() => {
              this.update_error = null;
              this.getOrganizationInfo();
            }, 2500);
          }
        })
        .catch((error) => {
          this.update_error = error.message;
          this.getEmployees();
        });
    },

    // /licenses/v1/renew
    renewLicense() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .put(
          `${this.getOrganization}/licenses/${this.$ApiVersion}/renew`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.update_success = response.data.StatusMessage;

              setTimeout(() => {
                this.update_success = null;
                this.getEmployees();
              }, 3000);
            } else {
              this.update_error = response.data.StatusMessage;

              setTimeout(() => {
                this.update_error = null;
                this.getEmployees();
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.update_error = error.message;
            this.getEmployees();
          }
        );
    },

    // /{organization}/organization/information/v1/request
    getOrganizationInfo() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      this.loading = true;

      axios
        .get(
          `${this.getOrganization}/organization/information/v1/request`,
          config
        )
        .then((response) => {
          this.loading = false;

          if (response.status === 200) {
            this.organizationInfo = response.data;
            const { Id, Name, Address, Email, PhoneNumber, Logo } =
              response.data.Data;
            this.info = {
              ...this.info,
              Id,
              Name,
              Address,
              Email,
              PhoneNumber,
              Logo,
            };
            this.getOrganizationLogo(Logo);
          }
          // Handle the organizationInfo data as needed
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getOrganizationLogo(logoUrl) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        responseType: "arraybuffer", // Include the responseType option in the config object
      };

      axios
        .get(logoUrl, config) // Pass the config object as the second argument
        .then((response) => {
          if (response.status === 200) {
            // Create a Blob from the response data
            const blob = new Blob([response.data], { type: "image/png" });

            // Create a URL for the Blob
            const imageURL = URL.createObjectURL(blob);
            this.info.Logo = imageURL;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
